import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { SnackbarNotificationType } from '@@/enums'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from '@@/library/v4/components/OzPlainButton.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBaseSnackbar',
  props: {
    uid: null,
    message: null,
    notificationType: { default: SnackbarNotificationType.success },
    iconName: { default: undefined },
    actionText: { default: undefined },
    darkMode: { type: [Boolean, String], default: 'auto' },
    shouldTruncate: { type: Boolean, default: false }
  },
  emits: ["action-text-click"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'action-text-click', event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {





const actionTextClick = (event): void => {
  emit('action-text-click', event)
}

return { __sfc: true,emit, actionTextClick, SnackbarNotificationType, OzIcon, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset }
}

})